<template>
  <a :class="'button ' + btnClasses" :href="href">
    <i v-if="icon" :class="icon"></i>
    {{ title }}
  </a>
</template>
<script>
export default {
  name: "LinkButton",
    props: {
        title: String,
        icon: String,
        href: String,
        btnClasses: {
            type: String,
            default: ""
        }
    }
};
</script>
